import cssGenerator from '../../css-generator';

const getResponsiveAttribute = (element, attr, breakpoint) => {
  const breakpoints = Object.keys(cssGenerator.constants.breakpoints);
  if (!breakpoints.includes(breakpoint)) {
    throw new Error('Invalid breakpoint provided');
  }

  const value = element && element.getAttribute(attr);
  const breakPointValue = value.split(' ').find((val) => {
    if (breakpoint) {
      return val.startsWith(`${breakpoint}:`);
    }

    return !val.includes(':');
  });

  if (breakPointValue) {
    return breakPointValue.split(':')[1];
  }

  return null;
};

export default getResponsiveAttribute;
